import React, { useRef, useState } from "react";
import { DISPLAY_URL, IFRAME_URL_NEW, MediaBaseUrl } from "../../../../actions/api";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import SendCodeByEmail from "../../../CommonComponents/SendCodeByEmail";
import { shallowEqual, useSelector } from "react-redux";
import $ from 'jquery'
import { baseUrl, getInitialRoute } from "../../../../utils";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";


const WebPageCompan = (props) => {

  
  const gettagRedux = useSelector((state) => state.Publish); 
  const {wallData} = useSelector((state) => state.wallData,shallowEqual); 
  
  const gettagReduxKey = gettagRedux?.tags ? gettagRedux?.tags[0] : [] || [];


  const getTags = gettagReduxKey.tags &&  gettagReduxKey.tags.length>0 && gettagReduxKey.geneRateStatus ? gettagReduxKey.tags.join('%2C') : ``;
  const embedTag =gettagReduxKey.tags &&  gettagReduxKey.tags.length>0 && gettagReduxKey.geneRateStatus ? `true` : `false`;


  const [embedWidthType, setembedWidthType] = useState('%');
  const [embedHeightType, setembedHeightType] = useState('%');

  const [IframeHeightType, setIframeHeightType] = useState('px');

  const [embedWidth, setembedWidth] = useState(100);
  
  const [embedHeight, setembedHeight] = useState(100);
  const [embedIframeHeight, setembedIframeHeight] = useState(600);
  const [openPopup, setOpenPopup] = useState(false)
  const [copyTooltip, setcopyTooltip] = useState(false);
  const getName = props.name ? props.name   : "";
  const getIndex = props.index ? props.index : "";
  const getPage = props.getPage ? props.getPage : "";
  const generateStatus = props.generateStatus ? true : false;

  const [code, setCode] = useState('lite_code');

  const embedRef = useRef();
  const liteCodeRef = useRef();
  const copyCode = (data) => {

    const refData = data == 1 ? embedRef : liteCodeRef;

    refData.current.select()
    navigator.clipboard.writeText(refData.current.value)

    setcopyTooltip(true);

    setTimeout(() => {
      setcopyTooltip(false);
      document.getSelection().removeAllRanges();
    }, 1000);
  }
  
 
  const liteCode = `<div class="taggbox" data-social-wall="true" style="width:${embedWidth}${embedWidthType};height:${embedHeight}${embedHeightType}" data-widget-id="${wallData.wallId}" ${`data-tags="${getPage==4 ? embedTag : 'false'}"`} ${getPage==4 && getTags && generateStatus ? `data-keywords="${getTags}"` : ""}></div><script src="${DISPLAY_URL}/embed.min.js" type="text/javascript"></script>`;

  const iframe = `<iframe src="${IFRAME_URL_NEW}${wallData.wallId}${getPage == 4 && getTags && generateStatus ? `?tags=${embedTag}` : ''}${getPage == 4 && getTags  && generateStatus ? `&data-keywords=${getTags}` : ""}" style="width:${embedWidth}${embedWidthType};height:${embedIframeHeight}${IframeHeightType};border:none;"></iframe>`;


  return (
    <>
      {getName == "Wordpress" ? (
        <>
          {" "}

          <h5 className="font-weight-bolder text-dark mb-5 mt-5">
            Option 1: Embed Widget On WordPress Website Seamlessly Using Plugin
          </h5>
          <div className="d-flex align-items-center justify-content-between flex-wrap px-5 py-3 border">
            <div className="d-flex align-items-center my-2">
              <div className="flex-shrink-0 me-3 mt-lg-0 mt-3">
                <div className="symbol symbol-circle symbol-lg-50">
                  <img
                    src={baseUrl(`logos/taggbox-small_logo.svg`)}
                    alt="Taggbox_Logo"
                  />
                </div>
                <div className="symbol symbol-lg-75 symbol-circle symbol-primary d-none">
                  <span className="font-size-h3 font-weight-boldest">LM</span>
                </div>
              </div>
              <div className="d-flex flex-column text-left">
                <h5 className="text-dark font-weight-boldest font-size-h5 mb-0">
                  Download Wordpress Plugin
                </h5>
                <span className="text-muted font-size-xs">Size : 2.2MB</span>
                <a
                  href="https://taggbox.com/support/how-to-use-taggbox-widget-plugin/"
                  target="_blank"
                  className="text-underline text-gradient text-hover-primary p-0 btn text-left font-size-sm"
                >
                  Installation Instructions
                </a>
              </div>
            </div>
            <div className="my-2">
              <a
                href="https://wordpress.org/plugins/taggbox-widget/"
                target="_blank"
                className="btn btn-primary btn-min-w"
              >
                 <FontAwesomeIcon type={'solid'} icon={'down-to-bracket'} iconClass={'me-1'} /> Download
              </a>
            </div>
          </div>
          <p className="font-weight-bolder p-5 text-center m-0">
            - OR -
          </p>
          <h5 className="font-weight-bolder text-dark mb-5">
            Option 2: Embed Widget On WordPress Website Using Embed Code
          </h5>
        </>
      ) : (
        ""
      )}
      <div className={`form-group mb-6 mb-lg-10 following_steps`}>
        <h6 className="mb-3 text-dark">
          1. Adjust the width and height of the widget as per your requirement
        </h6>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group mb-2">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">Width</span>
                </div>
                <input
                  type="number"
                  id="getWidth4"
                  onInput={(e)=>e.target.value = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1') }
                  className="form-control form-control-lg"
                  max={embedWidthType==`%` ? 100 : ``}
                  value={embedWidth} min={1} onChange={(e) => setembedWidth(embedWidthType == 'px' ? e.target.value : (e.target.value > 100 ? 100 : e.target.value))} />

                <div className="input-group-append">
                  <select onChange={(e) => { setembedWidthType(e.target.value); setembedWidth(e.target.value == '%' && embedWidth > 100 ? 100 : embedWidth) }} className="kt-selectpicker form-control form-control-lg appearance-none" id="embed-width7">
                    <option value="%">%</option>
                    <option value="px">px</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* code */}
          <div className="col-md-6">
            <div className="form-group mb-2">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">Height</span>
                </div>
                <input
                  type="number" 
                  pattern="^[0-9]*[.,]?[0-9]*$" 
                  id="getHeight4"
                  className="form-control form-control-lg"  
                  max={code=='lite_code' ? embedHeightType==`%` ? 100 : `` : IframeHeightType==`%` ? 100 : `` }
                  onInput={(e)=>e.target.value = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1') }
                  value={code=='lite_code' ? embedHeight : embedIframeHeight} min={1} onChange={(e) => code=='lite_code' ?  setembedHeight(embedHeightType == 'px' ? e.target.value : (e.target.value > 100 ? 100 : e.target.value)) : setembedIframeHeight(IframeHeightType == 'px' ? e.target.value : (e.target.value > 100 ? 100 : e.target.value))} />
                <div className="input-group-append"> 


                  <select value={ code=='lite_code' ?  embedHeightType : IframeHeightType} onChange={(e) => { code=='lite_code' ?  setembedHeightType(e.target.value) : setIframeHeightType(e.target.value);  code=='lite_code' ?  setembedHeight(e.target.value == '%' && embedHeight > 100 ? 100 : embedHeight) : setembedIframeHeight(e.target.value == '%' && embedIframeHeight > 100 ? 100 : embedIframeHeight) }} className="kt-selectpicker form-control form-control-lg appearance-none" id="embed-height7">
                      {code=='lite_code' ? 
                        <> <option value="%">%</option>
                        <option value="px"> px</option></> :
                        
                        <> <option value="px">px</option>
                        <option value="%"> % </option></> 
                        }
                  </select>

                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-group mb-6 mb-lg-10 following_steps">
          <h6 className="mb-3 text-dark"> 
          
           
         2. Copy the {getName==`Squarespace` ? `generated website embed code from the Taggbox Code Generator`  : (getName == `Shopify` ? `Generated code from Taggbox Code Generator` : `generated embed code`) } 
         
         {getName!='Squarespace' ? ` for your ${getName == 'Html' ? getName.toUpperCase() : getName} Website` : null }

          </h6>

          { getName == 'Other' ? <h6 className="mb-2 text-muted">Embed Code</h6> : null }
          
          <div className="embed_code_wrap">
            <ul
              className="nav nav-tabs nav-tabs-line mb-4"
              id="embed_code_2_"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active me-3"
                  id={`lite_html-2-tab-${getIndex}`}
                  data-bs-toggle="tab"
                  data-bs-target={`#lite_html-2-${getIndex}`}
                  type="button"
                  role="tab"
                  aria-controls={`lite_html-2-${getIndex}`}
                  aria-selected="true"
                  onClick={() => setCode(`lite_code`)}
                >
                  <FontAwesomeIcon type={'solid'} icon={'bolt-lightning'} iconClass={'fs-6 me-1'} />
                  Litecode
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link text-italic"
                  id={`embed_html-2-tab-${getIndex}`}
                  data-bs-toggle="tab"
                  data-bs-target={`#embed_html-2-${getIndex}`}
                  type="button"
                  role="tab"
                  aria-controls={`embed_html-2-${getIndex}`}
                  aria-selected="false"
                  onClick={() => setCode(`embed_html`)}

                >
                  Iframe
                </button>
              </li>
            </ul>
            <div
              className="tab-content mb-sm-3 mb-lg-4"
              id="embed_code_2_Content"
            >
              <div
                className="tab-pane fade show active"
                id={`lite_html-2-${getIndex}`}
                role="tabpanel"
                aria-labelledby={`lite_html-2-tab-${getIndex}`}
              >
                <div className="position-relative mb-0 embed_code">
                  <textarea
                    ref={liteCodeRef} onClick={(e) => { copyCode(2); e.target.select() }}
                    readOnly="readonly"
                    className="wallembedarea2 form-control border-0 rounded-0 copyme"
                    value={liteCode}
                  />
                  {copyTooltip ? <span id="copy-success-alert" style={{ display: 'block' }}>Copied!</span> : null}

                  <div className="emebed_action">

                  <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Copy Code</Tooltip>}>
                      <Button variant="link" onClick={(e) => copyCode(2)}
                        className="me-2 p-0 share_btn"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#shareCodeLite">
                          <FontAwesomeIcon type={'solid'} icon={'copy'} iconClass={'text-gray-500'} />
                      </Button>
                    </OverlayTrigger>
                      {openPopup == true ? <SendCodeByEmail show={openPopup} setOpenPopup={setOpenPopup} sharecode={{ 'liteCode': liteCode, 'iframe': iframe, 'code': code, 'getPage': getPage }} /> : ''}
                      <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Share Code</Tooltip>}>
                      <Button variant="link" className="p-0 share_btn"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#shareCodeLite"
                        onClick={(e) => setOpenPopup(true)}
                      >
                        <FontAwesomeIcon type={'solid'} icon={'envelope'} iconClass={'text-gray-500'} />
                      </Button>
                      </OverlayTrigger>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id={`embed_html-2-${getIndex}`}
                role="tabpanel"
                aria-labelledby={`embed_html-2-tab-${getIndex}`}
              >
                <div className="position-relative mb-0 embed_code">
                  <textarea
                    ref={embedRef} onClick={(e) => { copyCode(1); e.target.select() }}
                    readOnly="readonly"
                    className="iframeEmbedarea2 form-control border-0 rounded-0 copyme"
                    value={iframe}
                  />
                  {copyTooltip ? <span id="copy-success-alert" style={{ display: 'block' }}>Copied!</span> : null}

                  <div className="emebed_action">
                    <Button variant="link"
                      onClick={(e) => copyCode(1)}
                      className="p-0 me-2 copy-btn"
                      data-toggle="tooltip"
                      data-theme="dark"
                      title="Copy Code"

                    >
                      <FontAwesomeIcon type={'solid'} icon={'copy'} iconClass={'text-gray-500'} />
                    </Button>
                    
                    
                    <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip>Share Code</Tooltip>}>
                      <Button variant="link"
                        className="p-0 share_btn"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#shareCodeLite"
                        onClick={(e) => setOpenPopup(true)}
                      >
                        <FontAwesomeIcon type={'solid'} icon={'envelope'} iconClass={'text-gray-500'} />
                      </Button>
                      </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-group mb-6 mb-lg-10 following_steps">

         { getPage == 2 ? (
           <>
            <div className="form-group mb-6 mb-lg-10 following_steps">
                <h6 className="mb-3 text-dark">3. Paste the publish code into the backend of the webpage</h6>
                <ul className="publish_platform list-inline mb-6 ms-0 p-0 d-flex align-items-center flex-wrap">
                  <li className="me-2" href><img className="img-fluid" src={`${MediaBaseUrl}display-logo/publish-icon/wordpress.svg`} height={68} width={68} alt="wordpress" /></li>
                  <li className="me-2" href><img className="img-fluid" src={`${MediaBaseUrl}display-logo/publish-icon/html.svg`} height={68} width={68} alt="html" /></li>
                  <li className="me-2" href><img className="img-fluid" src={`${MediaBaseUrl}display-logo/publish-icon/wix.svg`} height={68} width={68} alt="wix" /></li>
                  <li className="me-2" href><img className="img-fluid" src={`${MediaBaseUrl}display-logo/publish-icon/squarespace.svg`} height={68} width={68} alt="squarespace" /></li>
                  <li className="me-2" href><img className="img-fluid" src={`${MediaBaseUrl}display-logo/publish-icon/shopify.svg`} height={68} width={68} alt="shopify" /></li>
                </ul>
                <h6 className="mb-3 text-dark">3. Paste the publish code into the backend of the page</h6>
                <p>Simply log in to your <strong> website</strong> and select the landing page where you wish to embed your widget</p>
                <p>Paste the embed code into the backend of the page</p>
                <p>Apply the required changes and Voila! You will have successfully published the widget on your website</p>
              </div>

              <div className="form-group mb-6 mb-lg-10">
                <div className="form-group">
                  <div className="d-flex align-items-center justify-content-start font-size-lg flex-wrap">
                    <span className="text-muted me-3">Don't know how to
                      install code?</span>
                    <a className="text-dark inst_guide d-flex align-items-center font-weight-boldest me-4" target="_blank" href="https://taggbox.com/support/how-to-embed-widget-on-html-website/" data-factors-click-bind="true">
                      Learn More
                      <FontAwesomeIcon type={'regular'} icon={'angle-right'} iconClass={''} />
                    </a>
                    <a onClick={() => {setTimeout(() => { $(".lity-hidden:last").hide() }, 100)}}  id={`video-${getIndex}`} href="https://player.vimeo.com/video/531736063" data-lity className="text-dark inst_guide d-flex align-items-center font-weight-boldest ms-2 me-4 lity_lightbox" data-factors-click-bind="true">
                      Watch Video
                      <FontAwesomeIcon type={'regular'} icon={'play'} iconClass={'ms-2'} />
                    </a>
                  </div>
                </div>
              </div>  
             </>  
        )  : 

          getName == "Html" ? (
            <>
              {" "}
              <h6 className="mb-3 text-dark">
                3. Paste the publish code into the backend of the page
              </h6>
              <p>
                Simply log in to your <strong>HTML website</strong> and select
                the landing page where you wish to embed your widget
              </p>
              <p>Paste the embed code into the backend of the page</p>
              <p>
                Apply the required changes and Voila! You will have successfully
                published the widget on your website
              </p>
            </>
          ) : getName == "Wordpress" ? (
            <>
              <h6 className="mb-3 text-dark">
                3. Paste the embed code into the backend of the page
              </h6>
              <p>Log in to your WordPress</p>
              <p>
                Select and edit the page where you want to embed the widget and
                apply changes to display it on your website
              </p>
              <p>Click on (+) to add new block and choose custom HTML</p>
              <p>Paste the copied code</p>
              <p>Click on Publish/Update post and You're Done!</p>
            </>
          ) : getName == "Wix" ? (
            <>
              <h6 className="mb-3 text-dark">
                3. Paste the publish code into the backend of the page
              </h6>
              <p>Log in to your Wix account</p>
              <p>
                Select and edit the page where you want to embed the widget and
                apply changes to display it on your website
              </p>
              <p>
                Click on <strong>(+)</strong> to add new block and choose{" "}
                <strong>Embed Code</strong> and select{" "}
                <strong>
                  <span></span> Embed HTML
                </strong>{" "}
                option
              </p>
              <p>
                Paste your copied code and click on <strong>Update</strong> to
                complete the process!
              </p>
            </>
          ) : getName == "Squarespace" ? (
            <>
              <h6 className="mb-3 text-dark">
                3. Paste the embed code into the backend of the page
              </h6>
              <p>
                Log into your Squarespace account and Open the page where you
                wish to Embed the Widget
              </p>
              <p>
                Click on <strong>+Add/Edit</strong> Block and Select{" "}
                <strong>Code</strong>{" "}
              </p>
              <p>
                Paste the copied code and click on <strong>apply</strong>
              </p>
              <p>Save the page and apply the changes</p>
            </>
          ) : getName == "Shopify" ? (
            <>
              <h6 className="mb-3 text-dark">
                3. Paste the embed code into the backend of the page
              </h6>

              <div
                className="accordion accordion-light accordion-toggle-arrow"
                id="Shopify_New"
              >
                <div className="card">
                  <div className="card-header" id="headingOne2">
                    <div
                      className="card-title"
                      data-bs-toggle="collapse"
                      data-bs-target="#defaultNew__"
                    >
                      <h4 className="font-weight-bolder text-dark py-5 m-0">
                        Default Page
                      </h4>
                    </div>
                  </div>
                  <div
                    id="defaultNew__"
                    className="collapse show"
                    data-parent="#Shopify_New"
                  >
                    <div className="card-body">
                      <p>
                        Log in to your Shopify store & go to Online Store {">"}{" "}
                        Themes menu in sidebar
                      </p>
                      <p>Go to Edit HTML/CSS option on top right of the page</p>
                      <p>
                        Select Layout/Templates/Section (Eg: For Homepage -
                        Index.liquid) Where you want to display widget
                      </p>
                      <p>
                        Paste the copied code and click on <strong>Save</strong>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" id="headingTwo2">
                    <div
                      className="card-title collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#new_page__New"
                    >
                      <h4 className="font-weight-bolder text-dark py-5 m-0">
                        New Page
                      </h4>
                    </div>
                  </div>
                  <div
                    id="new_page__New"
                    className="collapse"
                    data-parent="#Shopify_New"
                  >
                    <div className="card-body">
                      <p>
                        Login your Shopify store and Navigate to Online Store{" "}
                        {">"} Pages menu in sidebar
                      </p>
                      <p>Click on Add Page on Top right of page</p>
                      <p>
                        Select Show <strong>HTML {"(<>)"}</strong> option of
                        Text Editor
                      </p>
                      <p>
                        Paste the Copied code and Click on <strong>Save</strong>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" id="headingThree2">
                    <div
                      className="card-title collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#blog_posts__New"
                    >
                      <h4 className="font-weight-bolder text-dark py-5 m-0">
                        Blog Posts
                      </h4>
                    </div>
                  </div>
                  <div
                    id="blog_posts__New"
                    className="collapse"
                    data-parent="#Shopify_New"
                  >
                    <div className="card-body">
                      <p>
                        Login your Shopify store and Navigate to Online Store{" "}
                        {">"} Blog posts menu in sidebar
                      </p>
                      <p>Click on Add Blog post on Top right of page</p>
                      <p>
                        Select Show <strong>HTML {"(<>)"}</strong> option of
                        Text Editor
                      </p>
                      <p>
                        Paste the Copied code and Click on <strong>Save</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <h6 className="mb-3 text-dark">
                3. Copy the Generated code from Taggbox Code Generator
              </h6>
              <p>
                Here you can embed a widget on your website using either
                Javascript code or Iframe.
              </p>
              <p>Copy the Generated code from Taggbox Code Generator</p>
              <p>
                You can also adjust the height and width of your Widget before
                Generating a code
              </p>
              <p>Paste the Code on the backend of your website and save it.</p>
              <p>You’re Done! </p>
            </>
          )}
        </div>
      </>
      );
};

      export default WebPageCompan;
